// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"4b9d031c","145":"fe8a4802","222":"c3334da6","314":"a59b2129","421":"29c09d29","594":"a55a333a","638":"27c1a9d4","806":"3c752533","811":"687a5d3b","912":"25043854"}[chunkId] + ".chunk.js";
};